module.exports = __webpack_public_path__ + "static/learning-pyramid-f7a8f6a951d982e86f1fb850e531325b.png";